export default __webpack_public_path__ + "static/media/UniLogo.b32a5d5d.svg";